<template>
  <div>
    <b-modal
      id="form-detail-user-employee-modal"
      no-close-on-backdrop
      size="lg"
      title="Detail User Karyawan"
    >

      <b-row>
        <b-col cols="12" xl="12">
          <table class="table table-bordered table-sm table-striped">
            <tbody>
              <tr>
                <th><span class="font-weight-bold">Nama</span></th>
                <td>{{ result.name }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Username</span></th>
                <td>{{ result.username }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Email</span></th>
                <td>{{ result.email }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">No HP</span></th>
                <td>{{ result.phoneNumber }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Role</span></th>
                <td>
                  <ul>
                    <li v-for="item of result.roles">{{ item.roleName }}</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Akumulasi Gagal Login</span></th>
                <td>{{ result.attemptLogin }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Tanggal Aktivasi</span></th>
                <td>{{ result.activationDate }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Is Blok</span></th>
                <td>

                  <span v-if="result.isBlock">Ya</span> <span v-else>Tidak</span> |

                  <span v-if="result.isBlock">

                    <a href="" @click.prevent="blockUnblock()">UnBlock</a>

                    <!-- <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" :disabled="isLoadingBlock" @click="blockUnblock()">
                      <b-spinner class="mr-1" small variant="light" v-if="isLoadingBlock" />
                      Unblock
                    </b-button> -->
                  </span>
                  <span v-else>
                    <a href="" class="text-danger" @click.prevent="blockUnblock()">Block</a>
                    <!-- <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" :disabled="isLoadingBlock" @click="blockUnblock()">
                      <b-spinner class="mr-1" small variant="light" v-if="isLoadingBlock" />
                      Block
                    </b-button> -->
                  </span>

                </td>
              </tr>
              <tr>
                <td></td>
                <th><span @click="questionReset()" class="font-weight-bold reset">Reset Password</span></th>
              </tr>
              <tr>
                <td></td>
                <th>
                  <div class="question" v-if="isReset">
                    <b-overlay :show="loadingReset" opacity="0.6" spinner-small>
                      <b-button @click="resetPassword()" variant="primary" :disabled="loadingReset">Ya Reset</b-button>
                    </b-overlay>
                    <b-button @click="cancelReset()">Tidak</b-button>
                  </div>
                </th>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import { BCol, BAvatar, BRow, BButton, BSpinner, BOverlay } from "bootstrap-vue";
import BlobImage from "@/components/BlobImage.vue";
import { successNotification, errorNotification } from "@/auth/utils";
import utility from '../../libs/utility'

export default {
  components: {
    BCol,
    BAvatar,
    BRow,
    BlobImage,
    BButton,
    BSpinner,
    BOverlay
  },
  directives: {
    Ripple,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ["result"],
  data() {
    return {
      imageUrl: null,
      isLoadingBlock: false,
      isReset: false,
      loadingReset: false
    }
  },
  watch: {
    result(value) {

      this.$http
        .get(`/employee-activity/announcement?image=${value.image}`, {
          "responseType": 'blob'
        })
        .then((response) => {
            // return response.data
            // this.imageUrl = '/api/employee-activity/announcement?image=' + value.image
            this.imageUrl = URL.createObjectURL(response.data)


        })
        .catch((error) => {

        });
    },
  },
  methods: {
    blockUnblock() {
      const form = {
        isBlock: this.result.isBlock ? false : true,
        userId: this.result.userId
      };
      this.isLoadingBlock = true;

      this.$http
        .patch(`/user/block`, form, {
          headers: { "content-type": "application/json" },
        })
        .then((response) => {
          if (response.data.code !== '00' ) {
            errorNotification(this, "Oops!", response.data.message);
          } else {
            successNotification(this, "Success", "User berhasil di update!");
            window.location.reload();
          }

          this.isLoadingBlock = false;
        })
        .catch((error) => {
          errorNotification(this, "Oops!", error.response.data.message);
          this.isLoadingBlock = false;
        });


    },
    questionReset() {
      this.isReset = true;
    },
    cancelReset() {
      this.isReset = false;
    },
    resetPassword() {
      this.loadingReset = true;
      this.$http.patch(`/user/reset-password/${this.result.userId}`)
        .then((result) => {
          window.console.log(result);
          if (utility.ResponseCode(result)) {
            successNotification(this, "Success", "User Karyawan Berhasil di reset");
          }
          this.loadingReset = false;
          this.isReset = false;
        })
        .catch((e) => {
          errorNotification(this, "Oops!", error.response.data.message);
          this.loadingReset = false;
        });
    }
  }
};
</script>

<style scoped>
  .table .reset {
    color: tomato;
    cursor: pointer;
  }
  .question button {
    margin-right: 9px;
  }
  .question {
    position: relative;
    display: flex;
  }
</style>
